import UiVirtualScroll from '../../../../../../../../../components/VirtualScroll';
import { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OverlayTrigger, Tooltip, Modal, Button } from 'react-bootstrap';
import moment from 'moment/moment';
import {
  faAward,
  faUserMinus,
  faThumbsUp,
  faCircleQuestion,
  faCalculator,
  faAngle,
  faVolumeHigh,
  faVolumeSlash,
  faRetweet,
  faUpload,
  faCameraSlash,
  faClock,
  faLanguage,
  faLock,
  faMessagesQuestion,
  faChartArea,
  faSort,
  faShuffle,
  faEye,
  faEyeSlash,
  faCalendarDays,
  faEraser,
  faLockA,
  faAlarmExclamation,
  faTimer
} from '@fortawesome/pro-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { useAssignmentContext } from '../../../../../../../context';
import {
  useUnassignStudentsMutation,
  useSetAssignmentToReviewMutation
} from '../../../../../../../../../features/authentication/assignmentApislice';
import PropTypes from 'prop-types';
import FloatingMenu from '../../../../../../../../../components/floatingMenu/floatingMenu';
import HesSpinner from '../../../../../../../../../components/loadingOverlay/hesSpinner';
import CustomToast from '../../../../../../../../../components/Toast/index';
import ConfirmUnassignImg from '../../../../../../../../../assets/images/confirmUnassign.png';
import StudentClipboardImg from '../../../../../../../../../assets/images/studentClipboard.png';
import { faGear } from '@fortawesome/free-solid-svg-icons';

function generateAssignmentDetails(assignmentOptions, index, optionsPerRow) {
  let assignmentDetails = [];

  switch (assignmentOptions.mode) {
  case 0:
  case 4:
  case 6:
    assignmentDetails.push(
      <OverlayTrigger
        key={`assignmentMode-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-assignmentMode-${index}`} className="custom-tooltip">
              Assignment Mode: Open
          </Tooltip>
        }>
        <div
          className="assignmentOptions"
          style={{ color: '#48E0B2', backgroundColor: '#E3FFF6' }}>
            Open
        </div>
      </OverlayTrigger>
    );
    break;
  case 2:
  case 7:
  case 8:
  case 9:
    assignmentDetails.push(
      <OverlayTrigger
        key={`assignmentMode-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-assignmentMode-${index}`} className="custom-tooltip">
              Assignment Mode: Quiz
          </Tooltip>
        }>
        <div
          className="assignmentOptions"
          style={{ color: '#A29BFE', backgroundColor: '#E9E9FD' }}>
            Quiz
        </div>
      </OverlayTrigger>
    );
    break;
  case 1:
    assignmentDetails.push(
      <OverlayTrigger
        key={`assignmentMode-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-assignmentMode-${index}`} className="custom-tooltip">
              Assignment Mode: Locked
          </Tooltip>
        }>
        <div
          className="assignmentOptions"
          style={{ color: '#F84646', backgroundColor: '#FFE3E3' }}>
            Locked
        </div>
      </OverlayTrigger>
    );
    break;
  case 3:
    assignmentDetails.push(
      <OverlayTrigger
        key={`assignmentMode-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-assignmentMode-${index}`} className="custom-tooltip">
              Assignment Mode: Review
          </Tooltip>
        }>
        <div
          className="assignmentOptions"
          style={{ color: '#FFA800', backgroundColor: '#FFF4E3', fontSize: '1em' }}>
            Review
        </div>
      </OverlayTrigger>
    );
    break;
  case 5:
    assignmentDetails.push(
      <OverlayTrigger
        key={`assignmentMode-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-assignmentMode-${index}`} className="custom-tooltip">
              Assignment Mode: Offline
          </Tooltip>
        }>
        <div
          className="assignmentOptions"
          style={{ color: '#969696', backgroundColor: '#F0F2F8' }}>
            Offline
        </div>
      </OverlayTrigger>
    );
    break;
  case 11:
    assignmentDetails.push(
      <OverlayTrigger
        key={`assignmentMode-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-assignmentMode-${index}`} className="custom-tooltip">
              Assignment Mode: GradeCam
          </Tooltip>
        }>
        <div
          className="assignmentOptions"
          style={{ color: '#82A9E2', backgroundColor: '#E4EFFC' }}>
            GradeCam
        </div>
      </OverlayTrigger>
    );
    break;
  }

  switch (assignmentOptions.mode) {
  case 2:
    assignmentDetails.push(
      <OverlayTrigger
        key={`assignmentModeOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-assignmentModeOption-${index}`} className="custom-tooltip">
              Show grade upon completion of quiz
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#E3FFF6' }}>
          <FontAwesomeIcon icon={faEye} color="#48E0B2" />
        </div>
      </OverlayTrigger>
    );
    break;
  case 6:
    assignmentDetails.push(
      <OverlayTrigger
        key={`assignmentModeOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-assignmentModeOption-${index}`} className="custom-tooltip">
              Automatically lock questions
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#FFE3E3' }}>
          <FontAwesomeIcon icon={faLockA} color="#F84646" />
        </div>
      </OverlayTrigger>
    );
    break;
  case 8:
    assignmentDetails.push(
      <OverlayTrigger
        key={`assignmentModeOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-assignmentModeOption-${index}`} className="custom-tooltip">
              Allow changes to answers
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#FFF2F7' }}>
          <FontAwesomeIcon icon={faEraser} color="#FD79A8" />
        </div>
      </OverlayTrigger>
    );
    break;
  case 9:
    assignmentDetails.push(
      <OverlayTrigger
        key={`assignmentModeOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-assignmentModeOption-${index}`} className="custom-tooltip">
            {'Don\'t show grade upon completion of quiz'}
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#FFE3E3' }}>
          <FontAwesomeIcon icon={faEyeSlash} color="#F84646" />
        </div>
      </OverlayTrigger>
    );
    break;
  }

  // Past Due
  if (assignmentOptions.timedOut)
    assignmentDetails.push(
      <OverlayTrigger
        key={`assignmentTimedOut-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-assignmentTimedOut-${index}`} className="custom-tooltip">
            Past due
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#FFE3E3' }}>
          <FontAwesomeIcon icon={faAlarmExclamation} color="#F84646" />
        </div>
      </OverlayTrigger>
    );

  // From/To
  if (assignmentOptions.mode == 4 || assignmentOptions.availability) {
    var dateTimeOptions = {
      month: '2-digit',
      day: '2-digit',
      year: '2-digit',
      hour: 'numeric',
      minute: '2-digit'
    };
    assignmentDetails.push(
      <OverlayTrigger
        key={`assignmentTimedOut-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-assignmentTimedOut-${index}`} className="custom-tooltip">
            From/To
            <br />
            {`${new Date(assignmentOptions.availability.startDate).toLocaleString(
              'en-US',
              dateTimeOptions
            )} - ${new Date(assignmentOptions.availability.endDate).toLocaleString(
              'en-US',
              dateTimeOptions
            )}`}
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#D9F6FF' }}>
          <FontAwesomeIcon icon={faCalendarDays} color="#09BCF3" />
        </div>
      </OverlayTrigger>
    );
  }
  // Timed
  if (assignmentOptions.timeLimit) {
    var duration = moment.duration(assignmentOptions.timeLimit);
    assignmentDetails.push(
      <OverlayTrigger
        key={`timed-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-timedOption-${index}`} className="custom-tooltip">
            Assignment is timed:{' '}
            {`${duration.hours() > 0 ? duration.hours() + 'h' : ''} ${duration.minutes()}m`}
          </Tooltip>
        }>
        <div className="assignmentOptions assignmentOptionsIcon">
          <FontAwesomeIcon color="#82A9E2" icon={faTimer} />
        </div>
      </OverlayTrigger>
    );
  }
  // On screen calculator
  if (assignmentOptions.onScreenCalculator) {
    if (assignmentOptions.calculatorType == 1) {
      assignmentDetails.push(
        <OverlayTrigger
          key={`calculatorOption-${index}`}
          placement="top"
          overlay={
            <Tooltip id={`tooltip-calculatorOption-${index}`} className="custom-tooltip">
              A 4 Fucntion Calculator is available on screen for this assignment
            </Tooltip>
          }>
          <div className="assignmentOptions" style={{ backgroundColor: 'lightpink' }}>
            <FontAwesomeIcon color="red" icon={faCalculator} />
          </div>
        </OverlayTrigger>
      );
    } else if (assignmentOptions.calculatorType == 2) {
      assignmentDetails.push(
        <OverlayTrigger
          key={`calculatorOption-${index}`}
          placement="top"
          overlay={
            <Tooltip id={`tooltip-calculatorOption-${index}`} className="custom-tooltip">
              A Scientific Calculator is available on screen for this assignment
            </Tooltip>
          }>
          <div className="assignmentOptions" style={{ backgroundColor: '#E4EFFC' }}>
            <FontAwesomeIcon color="#82A9E2" icon={faCalculator} />
          </div>
        </OverlayTrigger>
      );
    }
  }

  // On screen protractor
  if (assignmentOptions.onScreenProtractor)
    assignmentDetails.push(
      <OverlayTrigger
        key={`protractorOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-protractorOption-${index}`} className="custom-tooltip">
            A protractor is available on screen for this assignment
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#F4FBE8' }}>
          <FontAwesomeIcon color="#88D111" icon={faAngle} />
        </div>
      </OverlayTrigger>
    );

  // Randomized questions
  if (assignmentOptions.questionsRandomized)
    assignmentDetails.push(
      <OverlayTrigger
        key={`randomizedOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-randomizedOption-${index}`} className="custom-tooltip">
            Questions are Randomized
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#FFF2F7' }}>
          <FontAwesomeIcon color="#FD79A8" icon={faShuffle} />
        </div>
      </OverlayTrigger>
    );

  // Re-takes enabled
  if (assignmentOptions.retakes)
    assignmentDetails.push(
      <OverlayTrigger
        key={`retakeOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-retakeOption-${index}`} className="custom-tooltip">
            Retakes Enabled
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#F2E5FF' }}>
          <FontAwesomeIcon icon={faRetweet} color="#9E5CDF" />
        </div>
      </OverlayTrigger>
    );

  // Text to speech enabled
  if (assignmentOptions.textToSpeech) {
    assignmentDetails.push(
      <OverlayTrigger
        key={`textToSpeechOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-textToSpeechOption-${index}`} className="custom-tooltip">
            Text-to-Speech Enabled
          </Tooltip>
        }>
        <div className='assignmentOptions bg-lightgreen'>
          <FontAwesomeIcon icon={faVolumeHigh} className='success-icon-btn' />
        </div>
      </OverlayTrigger>
    );

    // Text to speech disabled
  } else {
    assignmentDetails.push(
      <OverlayTrigger
        key={`textToSpeechOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-textToSpeechOption-${index}`} className="custom-tooltip">
            Text-to-Speech Disabled
          </Tooltip>
        }>
        <div className='assignmentOptions bg-lightred'>
          <FontAwesomeIcon icon={faVolumeSlash} className='danger-icon-btn' />
        </div>
      </OverlayTrigger>
    );
  }

  // Time on task
  if (assignmentOptions.timeOnTask)
    assignmentDetails.push(
      <OverlayTrigger
        key={`timeOnTaskOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-timeOnTaskOption-${index}`} className="custom-tooltip">
            The amount of time the student takes answering questions will be tracked
            <br />
            {`Maximum Time Per Question: ${assignmentOptions.timeOnTask}`}
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#D9F6FF' }}>
          <FontAwesomeIcon icon={faClock} color="#09BCF3" />
        </div>
      </OverlayTrigger>
    );

  // Photomath blocker
  if (assignmentOptions.photomathBlocker)
    assignmentDetails.push(
      <OverlayTrigger
        key={`photomathBlockerOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-photomathBlockerOption-${index}`} className="custom-tooltip">
            Photomath Blocker Enabled
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#FFE3E3' }}>
          <FontAwesomeIcon icon={faCameraSlash} color="#F84646" />
        </div>
      </OverlayTrigger>
    );

  // Language change
  if (assignmentOptions.allowLanguageChange)
    assignmentDetails.push(
      <OverlayTrigger
        key={`languageChangeOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-languageChangeOption-${index}`} className="custom-tooltip">
            The student will be allowed to change the display language while taking this assignment
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#E3FFF6' }}>
          <FontAwesomeIcon icon={faLanguage} color="#48E0B2" />
        </div>
      </OverlayTrigger>
    );

  // Browser lockdown
  if (assignmentOptions.browserLockdown)
    assignmentDetails.push(
      <OverlayTrigger
        key={`browserLockOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-browserLockOption-${index}`} className="custom-tooltip">
            The student will not be allowed have other browser tabs or windows open while taking
            this assignment.
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#FFE3E3' }}>
          <FontAwesomeIcon icon={faLock} color="#F84646" />
        </div>
      </OverlayTrigger>
    );

  // Student Upload File
  if (assignmentOptions.studentUploadFiles)
    assignmentDetails.push(
      <OverlayTrigger
        key={`studentFileUploadOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-studentFileUploadOption-${index}`} className="custom-tooltip">
            Student is allowed to upload files
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#E4EFFC' }}>
          <FontAwesomeIcon icon={faUpload} color="#82A9E2" />
        </div>
      </OverlayTrigger>
    );

  let detailRows = [];
  var keyIndex = 0;
  do {
    detailRows.push(
      <div
        key={`optionRow${index}${keyIndex}`}
        className={`d-flex flex-row ${keyIndex > 0 ? 'mt-2' : ''}`}>
        {assignmentDetails.splice(0, optionsPerRow).map((assignmentOption) => {
          return assignmentOption;
        })}
      </div>
    );
    keyIndex++;
  } while (assignmentDetails.length > 0);

  return <div className="d-flex flex-column">{detailRows}</div>;
}

function AssignedTable({
  assignedStudents,
  setAssignedStudents,
  selectedClassFilterIds,
  refetchCallback,
  dataStatus,
  assignmentHasCRQuestions,
  isIncludeCRQuestion,
  showAssignmentSettings,
  setShowAssignmentSettings
}) {
  const [showConfirmUnassignModal, setShowConfirmUnassignModal] = useState(false);
  const sortByAscending = useRef(true);
  const sortResultsBy = useRef('sort-lastName');
  const navigate = useNavigate();
  const { assignmentId } = useAssignmentContext();
  const [setAssignmentToReview, setAssignmentToReviewResults] = useSetAssignmentToReviewMutation();
  const [unassignStudents, unassignStudentsResult] = useUnassignStudentsMutation();
  const [showConfirmReviewModal, setShowConfirmReviewModal] = useState(false);

  const [floatingMenuButtons, setFloatingMenuButtons] = useState([
    {
      id: 1,
      name: 'CR Grading',
      tooltip: 'Grade CR questions for this assignment',
      icon: <FontAwesomeIcon icon={faAward} />,
      disabled: true,
    },
    {
      id: 2,
      name: 'Unassign Assignment',
      tooltip: 'This option allows you to unassign the Original Assignment.',
      icon: <FontAwesomeIcon icon={faUserMinus} />,
      disabled: true,
    },
    {
      id: 3,
      name: 'Set to Review Only (Includes any Retakes)',
      tooltip: 'Set to Review Only (Includes any Retakes)',
      icon: <FontAwesomeIcon icon={faThumbsUp} />,
      disabled: true,
    }
    , {
      id: 4,
      name: 'Assignment Settings',
      tooltip: 'Assignment Settings',
      icon: <FontAwesomeIcon icon={faGear} />,
      disabled: false,
      isEnabled: showAssignmentSettings
    }
  ]);

  const handleClick = (floatId) => {
    switch (floatId) {
    case 1:
      handleCrGrading();
      break;
    case 2:
      setShowConfirmUnassignModal(true);
      break;
    case 3:
      setShowConfirmReviewModal(true);
      break;
    case 4:
      setShowAssignmentSettings(!showAssignmentSettings);
      updateSettings(!showAssignmentSettings);
      break;
    }
  };

  const updateSettings = (isEnabled) =>{
    let tempArray = [...floatingMenuButtons];
    tempArray[3].isEnabled = isEnabled;
    setFloatingMenuButtons(tempArray);
  };

  useEffect(() => {
    if (assignmentHasCRQuestions) {
      let tempArray = [...floatingMenuButtons];
      tempArray[0].disabled = isIncludeCRQuestion ? false : true;
      setFloatingMenuButtons(tempArray);
    }
  }, []);

  const handleCrGrading = () => {
    navigate(`/assignments/${assignmentId}/grade_constructiveResponses`);
  };

  const handleAssignmentChecked = (e) => {
    const { name, checked } = e.target;
    let tempAssignmentResults = [];

    if (name === 'allselect') {
      tempAssignmentResults = assignedStudents.map((item) => {
        return { ...item, isChecked: checked };
      });
    } else {
      tempAssignmentResults = assignedStudents.map((item) =>
        item.studentId == name ? { ...item, isChecked: checked } : item
      );
    }
    setAssignedStudents(tempAssignmentResults);

    let tempButtons = [...floatingMenuButtons];
    const disableButtons = tempAssignmentResults.filter((s) => s.isChecked == true).length == 0;
    tempButtons = tempButtons.map((button) => {
      return button.id == 1 ? button : { ...button, disabled: disableButtons };
    });
    setFloatingMenuButtons(tempButtons);
  };

  async function handleSetAssignmentToReview() {
    try {
      var selectedStudentIds = assignedStudents
        .filter((s) => s.isChecked == true)
        .map((s) => s.studentId);
      var reviewResult = await setAssignmentToReview({
        originalAssignmentId: assignmentId,
        studentIds: selectedStudentIds
      }).unwrap();
      setShowConfirmReviewModal(false);
      if (reviewResult.length == selectedStudentIds.length) {
        CustomToast('Original and retake assignments set to review', 'success');
      } else {
        CustomToast('Not all original and retake assignments set to review', 'warning');
      }
      refetchCallback();
    } catch {
      CustomToast('Something went wrong trying to set assignment(s) to review', 'error');
    }
  }

  const handleAssignmentSort = (e) => {
    let sortedAssignmentResults = [...assignedStudents];
    if (e) sortByAscending.current = !sortByAscending.current;
    switch (sortResultsBy.current) {
    case 'sort-lastName':
      sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
        a.studentLastName > b.studentLastName ? 1 : -1
      );
      break;
    case 'sort-firstName':
      sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
        a.studentFirstName > b.studentFirstName ? 1 : -1
      );
      break;
    case 'sort-className':
      sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
        a.className > b.className ? 1 : -1
      );
      break;
    case 'sort-status':
      sortedAssignmentResults = sortedAssignmentResults.sort(
        (a, b) => a.crAnsweredCount - b.crAnsweredCount
      );
      break;
    default:
      sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
        a.studentLastName > b.studentLastName ? 1 : -1
      );
    }
    if (!sortByAscending.current) sortedAssignmentResults.reverse();

    setAssignedStudents(sortedAssignmentResults);
  };

  async function handleUnassignStudents() {
    try {
      var selectedStudents = assignedStudents
        .filter((s) => s.isChecked == true)
        .map((s) => s.studentId);

      await unassignStudents({ assignmentId: assignmentId, studentIds: selectedStudents }).unwrap();
      refetchCallback();

      let tempButtons = [...floatingMenuButtons];
      tempButtons = tempButtons.map((button) => {
        return button.id == 1 ? button : { ...button, disabled: true };
      });
      setFloatingMenuButtons(tempButtons);
      setShowConfirmUnassignModal(false);

      CustomToast(
        `${selectedStudents.length} student${selectedStudents.length === 1 ? ' has' : 's have'
        } been removed from the assignment`,
        'success'
      );
    } catch {
      CustomToast('Something went wrong trying to unassign the assignment', 'error');
    }
  }
  return (
    <div className="custom-table table-responsive">
      <UiVirtualScroll rowHeight={60} height="400px">
        <table className="table">
          <thead>
            <tr>
              <th>
                <input
                  type="checkbox"
                  className="form-check-input"
                  value=""
                  id="flexCheckDefault"
                  name="allselect"
                  checked={assignedStudents?.filter((item) => item?.isChecked !== true).length < 1}
                  onChange={handleAssignmentChecked}
                  defaultChecked={false}
                />
              </th>
              <th>
                Last Name
                <button
                  className="sort-btn"
                  id="sort-lastName"
                  onClick={(e) => {
                    sortResultsBy.current = e.target.id;
                    handleAssignmentSort(e);
                  }}>
                  <FontAwesomeIcon icon={faSort} />
                </button>
              </th>
              <th>
                First Name
                <button
                  className="sort-btn"
                  id="sort-firstName"
                  onClick={(e) => {
                    sortResultsBy.current = e.target.id;
                    handleAssignmentSort(e);
                  }}>
                  <FontAwesomeIcon icon={faSort} />
                </button>
              </th>
              <th>
                Class
                <button
                  className="sort-btn"
                  id="sort-className"
                  onClick={(e) => {
                    sortResultsBy.current = e.target.id;
                    handleAssignmentSort(e);
                  }}>
                  <FontAwesomeIcon icon={faSort} />
                </button>
              </th>
              <th>
                Status
                <button
                  className="sort-btn"
                  id="sort-status"
                  onClick={(e) => {
                    sortResultsBy.current = e.target.id;
                    handleAssignmentSort(e);
                  }}>
                  <FontAwesomeIcon icon={faSort} />
                </button>
              </th>
              <th>
                Details
                <OverlayTrigger
                  key={'detailstooltip'}
                  placement="right"
                  overlay={
                    <Tooltip className="initial-assignment-tooltip">
                      <div>
                        <div>
                          <p>
                            The <strong>Details</strong> indicates assignment mode, whether
                            Text-to-Speech is enabled or disabled, and whether the assignment is
                            randomized. An R indicates the assignment is randomized. If the
                            Text-to-Speech icon has a red cross through it, that indicates that
                            Text-to-Speech is disabled.
                          </p>
                          <p>
                            The <strong>Assignment Mode</strong> indicates how students can interact
                            with the assignment.
                          </p>
                          <ul>
                            <li>
                              <strong>Open</strong>: allows students full access to all questions,
                              with all available feedback.
                            </li>
                            <li>
                              <strong>Quiz</strong>: students can answer the questions but do not
                              get any feedback.
                            </li>
                            <li>
                              <strong>Offline</strong>: Locked to students who work on the
                              assignment offline. Student answers uploaded by the teacher. Only
                              available if the assignment contains just multiple choice questions.
                            </li>
                          </ul>

                          <p>
                            The <strong>Availability Options</strong> controls when a student has
                            access to the assignment
                          </p>
                          <ul>
                            <li>
                              <strong>Always:</strong> allows students full access to all questions
                              at all times.
                            </li>
                            <li>
                              <strong>From/To:</strong> allows students to work on the assignment
                              within a date and time range.
                            </li>
                          </ul>

                          <p>
                            The <strong>Timed</strong> option allows the student to work on an
                            assignment for the specified amount of time. Timer starts when the
                            student opens the assignment.
                          </p>
                          <br />
                        </div>
                      </div>
                    </Tooltip>
                  }>
                  <FontAwesomeIcon icon={faCircleQuestion} color="#88CBF1" />
                </OverlayTrigger>
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {dataStatus.isError && (
              <tr>
                <td colSpan="7" style={{ textAlign: 'center' }}>
                  <button
                    style={{
                      color: '#F84646',
                      fontSize: '1.15rem',
                      border: 'none',
                      background: 'none'
                    }}
                    onClick={() => refetchCallback()}>
                    There was an error getting the data. Click to try again
                  </button>
                </td>
              </tr>
            )}
            {dataStatus.isFetching && (
              <tr>
                <td colSpan="7">
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: '40px' }}>
                    <HesSpinner />
                    <span className="ms-3">Loading results...</span>
                  </div>
                </td>
              </tr>
            )}

            {!dataStatus.isFetching &&
              dataStatus.isSuccess &&
              (assignedStudents.length == 0 ||
                assignedStudents.filter((item) => selectedClassFilterIds.includes(item.classId))
                  .length == 0) && (
              <tr>
                <td colSpan="7">
                  <div
                    className="d-flex align-items-end justify-content-center text-align-center"
                    style={{
                      backgroundImage: `url(${StudentClipboardImg})`,
                      backgroundRepeat: 'no-repeat',
                      height: '130px',
                      backgroundPositionX: 'center'
                    }}>
                    {assignedStudents.length == 0 ? (
                      <span>There are no students assigned to this assignment</span>
                    ) : (
                      <span>{`There are no assigned students within the selected class${selectedClassFilterIds.length === 1 ? '' : 'es'
                      }`}</span>
                    )}
                  </div>
                </td>
              </tr>
            )}

            {dataStatus.isSuccess &&
              assignedStudents.map((item, index) => {
                if (!selectedClassFilterIds.includes(item.classId) || item.isRemoved) return;

                let bestScore = 0;
                if (item.retakeResults) {
                  let retakes = [...item.retakeResults];
                  retakes
                    .sort(
                      (a, b) =>
                        a.retriesAsNoCreditScore?.percent - b.retriesAsNoCreditScore?.percent
                    )
                    .reverse();
                  bestScore = retakes[0]?.retriesAsNoCreditScore;
                  if (item.retriesAsNoCreditScore?.percent > bestScore?.percent)
                    bestScore = item.retriesAsNoCreditScore;
                }

                return (
                  <tr key={`assignedStudentRow_${index}`}>
                    <td>
                      <input
                        type="checkbox"
                        value=""
                        name={item.studentId}
                        checked={item?.isChecked || false}
                        onChange={handleAssignmentChecked}
                        className="form-check-input"
                        id={`flexCheckDefault${item.assignmentId}`}
                      />
                    </td>
                    <td>{item.studentLastName}</td>
                    <td>{item.studentFirstName}</td>
                    <td>{item.className}</td>
                    <td>
                      <div
                        className={`assignmentStatus ${item.dateStarted ? 'started' : 'notStarted'
                        }`}>
                        {item.dateStarted ? 'Started' : 'Not Started'}
                      </div>
                    </td>

                    <td>{generateAssignmentDetails(item.assignmentOptions, index, 7)}</td>
                    <td>
                      <div className="d-flex flex-row justify-content-end">
                        <OverlayTrigger
                          key={`reponsesReport-${index}`}
                          placement="top"
                          overlay={
                            <Tooltip
                              id={`tooltip-reponsesReport-${index}`}
                              className="custom-tooltip">
                              Responses
                            </Tooltip>
                          }>
                          <div
                            className="assignmentOptions"
                            style={{ backgroundColor: '#F0F2F8', cursor: 'pointer' }}>
                            <FontAwesomeIcon icon={faMessagesQuestion} color="#969696" />
                          </div>
                        </OverlayTrigger>

                        <OverlayTrigger
                          key={`studentSessionReport-${index}`}
                          placement="top"
                          overlay={
                            <Tooltip
                              id={`tooltip-studentSessionReport-${index}`}
                              className="custom-tooltip">
                              Student Session Report
                            </Tooltip>
                          }>
                          <div
                            className="assignmentOptions"
                            style={{ backgroundColor: '#F0F2F8', cursor: 'pointer' }}>
                            <FontAwesomeIcon icon={faChartArea} color="#969696" />
                          </div>
                        </OverlayTrigger>
                      </div>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </UiVirtualScroll>
      <div className="floating-menu">
        <FloatingMenu floatingButtons={floatingMenuButtons} onClick={handleClick} />
      </div>
      <Modal
        show={showConfirmUnassignModal}
        onHide={() => setShowConfirmUnassignModal(false)}
        size="lg"
        centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <h1>Unassign Assignment</h1>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-column align-items-center">
            <div
              style={{
                backgroundImage: `url(${ConfirmUnassignImg})`,
                backgroundRepeat: 'no-repeat',
                height: '120px',
                width: '140px'
              }}></div>

            <div style={{ fontSize: '1rem', fontWeight: '600' }}>
              Are you sure that you want to unassign the assignment from the checked students?
            </div>
            <div className="my-3 text-center">
              By unassigning from students who have started the assignment, you will no longer be
              able to view their results for this assignment.
            </div>

            <div className="d-flex flex-row justify-content-even w-50">
              <Button
                className="w-50"
                variant="castleGray"
                onClick={() => setShowConfirmUnassignModal(false)}>
                No
              </Button>
              <Button
                className="ms-3 w-50"
                variant="castleRed"
                onClick={() => handleUnassignStudents()}
                disabled={unassignStudentsResult.isLoading}>
                Yes
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showConfirmReviewModal}
        onHide={() => setShowConfirmReviewModal(false)}
        size="lg"
        centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <h1>Confirm</h1>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-column align-items-center">
            <div className="my-2" style={{ fontSize: '1rem', fontWeight: '600' }}>
              Are you sure you want to set the original assignments and retakes to review?
            </div>

            <div className="d-flex flex-row justify-content-even w-50">
              <Button
                className="w-50"
                variant="castleGray"
                onClick={() => setShowConfirmReviewModal(false)}>
                No
              </Button>
              <Button
                className="ms-3 w-50"
                variant="castleRed"
                onClick={() => handleSetAssignmentToReview()}
                disabled={setAssignmentToReviewResults.isLoading}>
                Yes
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

AssignedTable.propTypes = {
  assignedStudents: PropTypes.array.isRequired,
  setAssignedStudents: PropTypes.object,
  selectedClassFilterIds: PropTypes.array,
  refetchCallback: PropTypes.function,
  dataStatus: PropTypes.object,
  assignmentHasCRQuestions: PropTypes.bool,
  isIncludeCRQuestion: PropTypes.bool,
  showAssignmentSettings: PropTypes.bool,
  setShowAssignmentSettings: PropTypes.func
};

export default AssignedTable;
